<template>
  <div id="app">
    <nav-bar />
    <banner />
    <router-view />
    <footer-comp />
  </div>
</template>

<script>
import NavBar from "@/components/navbar";
import Banner from "@/components/banner";
import FooterComp from "@/components/footer";
export default {
  name: "App",
  components: {
    NavBar,
    Banner,
    FooterComp,
  },
};
</script>

<style>
html,
body {
  height: 100%;
  width: 100%;
}
body {
  padding-top: 50px;
}
#app {
  font-family: SourceHanSansSC;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
p{
  margin:0;
}
.swiper-pagination-bullet.swiper-pagination-bullet-active {
  background-color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue